import Resource from "./resource";

export default class Lead extends Resource {

	get name() {
		return `${this.dto.first_name} ${this.dto.last_name}`;
	}
}
